(function(root) {
  "use strict";
  // Theme advertisement adapters and migration cleanup. No consent policy lives here.
  const consent = root.LegitGrails.cookieConsent;
  const integrations = consent.integrations;
  const vendorLoadState = {};
  const isAllowed = integrations.isAllowed;
  const insertScript = integrations.insertScript;
  const removeCookie = integrations.removeCookie;
  const removeCookiesMatching = integrations.removeCookiesMatching;
  const removeLocalStorageKey = integrations.removeLocalStorageKey;
  const registerCleanupHook = integrations.registerCleanupHook;
  function warn() { if (root.console && root.console.warn) root.console.warn.apply(root.console, arguments); }
  registerCleanupHook("advertisement", function() {
    if (typeof root.clarity === "function") {
      root.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "denied" });
      root.clarity("consent", false);
      root.clarity("stop");
    }
  });
  registerCleanupHook("advertisement", function() {
    // Prevent our pending Insight SDK from initializing after a revoked download.
    if (root._linkedin_partner_id === "3803522") delete root._linkedin_partner_id;
    if (Array.isArray(root._linkedin_data_partner_ids)) {
      root._linkedin_data_partner_ids = root._linkedin_data_partner_ids.filter(function(id) { return id !== "3803522"; });
    }
  });
  // Accessible state from external pixels is migration/cleanup only, not SDK ownership.
  registerCleanupHook("advertisement", function() {
    removeCookiesMatching(/^(?:_gcl_.+|_gac_.+|gclid|_fbp|_fbc|_tt_enable_cookie|_ttp|ttp|ttcsid(?:_.+)?|ttclid|_pangle|_uetsid|_uetvid|_uetmsclkid|_clck|_clsk|_pin_unauth|_epik|_derived_epik|_pin_aem|_pinterest_ct_ua|_rdt_(?:uuid|cid|em|pn)|_gtmeec|gtmeec)$/);
    ["_gcl_ls", "lastExternalReferrer", "lastExternalReferrerTime", "_uetsid", "_uetvid", "_uetmsclkid", "_uetsid_exp", "_uetvid_exp", "li_adsId", "gtmeec"].forEach(removeLocalStorageKey);
    try { ["tt_sessionId", "tt_pixel_session_index", "tt_appInfo", "_cltk"].forEach(function(key) { root.sessionStorage.removeItem(key); }); } catch (error) {}
  });

  function cleanupKlaviyoBrowserState() {
    // Both purposes are required by the Shopify pixel. Also clear accessible
    // anonymous queues/identity so a later opt-in cannot backfill revoked state.
    ["shopify_client_id", "__kla_id", "__kle_id"].forEach(removeCookie);
    ["kl-post-identification-sync", "__kla_id", "__kle_id"].forEach(removeLocalStorageKey);
    try { root.sessionStorage.removeItem("_kx"); } catch (error) {}
  }
  registerCleanupHook("analytics", cleanupKlaviyoBrowserState);
  registerCleanupHook("advertisement", cleanupKlaviyoBrowserState);
  registerCleanupHook("analytics", function() {
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach(removeCookie);
  });

  // These projects are retired. Cleanup is migration-only, never an SDK loader.
  function cleanupRetiredVendors() {
    removeCookie("mp_a7ca68b124cec3facdd181fd9f6b4a15_mixpanel");
    removeLocalStorageKey("mp_a7ca68b124cec3facdd181fd9f6b4a15_mixpanel");
    removeLocalStorageKey("__mp_opt_in_out_a7ca68b124cec3facdd181fd9f6b4a15");
    removeCookiesMatching(/^(_vwo|_vis_opt|wingify_|pushcrew_|pshcrw_)/i);
    removeLocalStorageKey("_wingify_1247094_config");
  }

  /**
   * Loads LinkedIn Insight after advertisement consent and user interaction.
   */
  function loadLinkedInInsight() {
    if (vendorLoadState.linkedin) return vendorLoadState.linkedin;

    vendorLoadState.linkedin = Promise.resolve()
      .then(function() {
        if (!isAllowed("advertisement")) return null;
        let partnerId = "3803522";

        root._linkedin_data_partner_ids = root._linkedin_data_partner_ids || [];
        if (root._linkedin_data_partner_ids.indexOf(partnerId) === -1) {
          root._linkedin_data_partner_ids.push(partnerId);
        }
        root._linkedin_partner_id = partnerId;

        if (!root.lintrk) {
          root.lintrk = function(a, b) {
            root.lintrk.q.push([a, b]);
          };
          root.lintrk.q = [];
        }

        return insertScript("legitgrails-linkedin-insight", "https://snap.licdn.com/li.lms-analytics/insight.min.js");
      })
      .catch(function(error) {
        vendorLoadState.linkedin = null;
        warn("LinkedIn Insight load failed", error);
        return null;
      });

    return vendorLoadState.linkedin;
  }

  /**
   * Loads Microsoft Clarity after advertisement consent and user interaction.
   */
  function loadClarity() {
    if (vendorLoadState.clarity) return vendorLoadState.clarity;

    vendorLoadState.clarity = Promise.resolve()
      .then(function() {
        if (!isAllowed("advertisement")) return null;
        let clarityScript;

        (function(c,a){
          c[a] = c[a] || function() {
            (c[a].q = c[a].q || []).push(arguments);
          };
          clarityScript = insertScript("legitgrails-clarity", "https://www.clarity.ms/tag/qbtjpzcwos");
        })(root, "clarity");

        root.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "denied" });
        return clarityScript.then(function() {
          const allowed = isAllowed("advertisement");
          root.clarity("consentv2", { ad_Storage: allowed ? "granted" : "denied", analytics_Storage: allowed ? "granted" : "denied" });
          if (!allowed) root.clarity("stop");
        });
      })
      .catch(function(error) {
        vendorLoadState.clarity = null;
        warn("Clarity load failed", error);
        return null;
      });

    return vendorLoadState.clarity;
  }


  cleanupRetiredVendors();
  integrations.registerAdapter({ id: "linkedin", category: "advertisement", requiresInteraction: true,
    sync: function() { if (isAllowed("advertisement")) return loadLinkedInInsight(); } });
  integrations.registerAdapter({ id: "clarity", category: "advertisement", requiresInteraction: true,
    sync: function() { if (isAllowed("advertisement")) return loadClarity(); } });
})(window);
